module.exports = __webpack_public_path__ + "static/media/piotrek.1041189f.jpg";